// extracted by mini-css-extract-plugin
export default {"price":"r9-z","priceRow":"s9-z","onSale":"t9-z","msrpLabelPrice":"u9-z","msrpLabel":"v9-z","originalPrice":"w9-z","percentOff":"x9-z"};